/**
 * Created by fajar on 03/12/2018.
 * Updated by cahyo on 02/01/2019.
 *
 * File base environment for development
 * and production and can validasi by alias
 * 'environment' which has selected
 */

export default {
	MAX_CHAR_SEARCH_NAME: 3,
	ASSETS_URL: '/static/',
	OFFSET: 0,
	LIMIT: 10,
	MAX_LIMIT: 250,
	MAX_TIMEOUT: 60000,

	LOCALE: 'id',
	DEFAULT_ROUTE_PATH: '/',
	HOME_ROUTE_PATH: '/index',
	RELOAD_LOGIN_LOGOUT: true
};
